const LOCALE = 'es-CL';

const parse = (iso: string | null | undefined): Date | null => {
	if (!iso || iso === 'unknown') return null;
	const d = new Date(iso);

	return Number.isNaN(d.getTime()) ? null : d;
};

/** `14:22` — the timestamp that sits inside a chat bubble. */
export const formatClockTime = (iso: string | null | undefined): string =>
	parse(iso)?.toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit' }) ?? '—';

/** `14:22:08` — second precision, for the internal event timeline. */
export const formatEventTime = (iso: string | null | undefined): string =>
	parse(iso)?.toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit', second: '2-digit' }) ?? '—';

/** `10 ago 2026, 14:22` — the sidebar's absolute timestamps. */
export const formatDateTime = (iso: string | null | undefined): string =>
	parse(iso)?.toLocaleString(LOCALE, {
		day: '2-digit',
		month: 'short',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	}) ?? '—';

/** `May 12, 2026` / `12 may 2026` — a date in the UI's own language. */
export const formatDate = (iso: string | null | undefined, locale: string): string =>
	parse(iso)?.toLocaleDateString(locale, { day: '2-digit', month: 'short', year: 'numeric' }) ?? '—';

export const formatDuration = (ms: number): string => (ms >= 1000 ? `${(ms / 1000).toFixed(1)} s` : `${ms} ms`);
